import React from 'react';

import { BasePopupActionPayload, BasePopupProps } from 'contexts/PopupContext';
import { PopupAds } from 'types/interfaces/ads/PopupAds';

import { useDynamicBannerAnalytics } from 'hooks/analytics/useDynamicBannerAnalytics';

import { BaseButton, ButtonTypes } from 'components/base/BaseButton';
import { AdsCreative } from 'components/shared/AdsCreative';
import { ImagedPopup } from 'components/UI/ImagedPopup';

import css from './adsVideoPopup.module.sass';

type ActionsPayload = BasePopupActionPayload<'close'>;

type Props = BasePopupProps<PopupAds, (action: ActionsPayload) => void>;

export const AdsVideoPopup: React.FC<Props> = ({ data, onAction }) => {
  const { trackBannerLoad } = useDynamicBannerAnalytics();

  const handleCloseClick = () => {
    onAction({ type: 'close' });
  };

  const handleLoad = () => {
    trackBannerLoad({
      banner: data,
      requestTs: Date.now(),
    });
  };

  return (
    <ImagedPopup
      image={
        <AdsCreative
          href={data.url}
          src={data.image_url}
          linkClassName={css.thumbnailLink}
          creativeClassName={css.thumbnailMedia}
          onClick={handleCloseClick}
          onLoad={handleLoad}
        />
      }
      icon={
        <AdsCreative
          href={data.url}
          src={data.image2_url}
          linkClassName={css.thumbnailLink}
          creativeClassName={css.thumbnailMedia}
          onClick={handleCloseClick}
        />
      }
      onClose={handleCloseClick}
    >
      <p className={css.title}>{data.text}</p>
      <p className={css.subtitle}>{data.text2}</p>

      <a href={data.url} target="_blank" rel="noreferrer">
        <BaseButton
          type={ButtonTypes.Primary}
          className={css.button}
          onClick={handleCloseClick}
        >
          {data.button}
        </BaseButton>
      </a>
    </ImagedPopup>
  );
};
